export { default } from './BancoDoAutoMoto25Banner';
